import { ModalContent } from './types'

export function ConfirmReceiveDocumentModalHook() {
  const modalContent: ModalContent = {
    title: 'ยืนยันการรับเอกสารฉบับจริง',
    content: 'คุณได้ตรวจสอบเอกสารฉบับจริงที่ได้รับว่าถูกต้องและครบถ้วน',
    confirmText: 'ยืนยัน',
    cancelText: 'ยกเลิก',
  }

  return {
    modalContent,
  }
}
